module.exports = __webpack_public_path__ + "img/f4.5ecb9bf6.jpg";